import { useState } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { Dialog, DialogFace, Link, Table } from 'ui/components'

import { useAlertsReportContext } from '../../context/reportContext'
import { ClientUser } from '../../types'
import { columns } from './columns'

export const AlertsTable = () => {
  const {
    data: {
      form: { page, size },
      total,
      items
    },
    routeApi,
    isFetching
  } = useAlertsReportContext()
  const navigate = routeApi.useNavigate()

  const [showClientUsers, setShowClientUsers] = useState(false)
  const [clientUsers, setClientUsers] = useState<ClientUser[]>([])

  const showClientUsersCallback = (clientUsers: ClientUser[]) => {
    setClientUsers(clientUsers)
    setShowClientUsers(true)
  }

  return (
    <>
      <Table
        dataQa={TableDataQa.BP_REPORTS_ALERTS_REPORT}
        columns={columns(showClientUsersCallback)}
        dataSource={items.map((item) => ({ item }))}
        pagination={{
          page,
          size,
          onChange: (page, size) => {
            navigate({ to: '.', search: (prev) => ({ ...prev, page, size }) })
          },
          total
        }}
        loading={isFetching}
      />
      {showClientUsers && (
        <Dialog
          id="client-users"
          face={DialogFace.PRIMARY}
          title="Client Users"
          onClose={() => setShowClientUsers(false)}
        >
          <Table<ClientUser>
            dataQa={TableDataQa.BP_REPORTS_ALERTS_REPORT_CLIENT_USERS}
            columns={[
              {
                align: 'left',
                title: 'Name',
                key: 'name'
              },
              {
                align: 'left',
                title: 'Email',
                render: ({ email }) => <Link to={`mailto:${email}` as never}>{email}</Link>
              }
            ]}
            dataSource={clientUsers.map((el) => ({ item: el }))}
          />
        </Dialog>
      )}
    </>
  )
}
